import { render, staticRenderFns } from "./ProductAccessView.vue?vue&type=template&id=4e052355&scoped=true"
import script from "./ProductAccessView.vue?vue&type=script&lang=js"
export * from "./ProductAccessView.vue?vue&type=script&lang=js"
import style0 from "./ProductAccessView.vue?vue&type=style&index=0&id=4e052355&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e052355",
  null
  
)

export default component.exports